export const gConf = {
	window: {
		width: 700,
		height: 700,
	},
	camera: {
		radius: 210,
	},
	globe: {
		radius: 100,
	},
	marker: {
		size: 30,
	},
};
